<template>
    <span>
        <!-- Use line below to make fraction numbers smaller -->
        <!--{{ getValue.int }}<span class="amount-frac">{{ getValue.frac }}</span>-->
        {{ getValue.int }}<span>{{ getValue.frac }}</span>
    </span>
</template>

<script>
export default {
    props: {
        amount: {
            type: [String, Number],
            required: true,
        },
        decimals: {
            type: Number,
            defaultValue: 9,
        },
    },

    computed: {
        getValue() {
            return this.$ton(this.amount, this.decimals, false, true);
        },
    },
};
</script>

<style lang="scss">
.amount-frac {
    font-size: 12px;
}
</style>
